export default function () {
  return {
    all: [],
    allTopics: [],
    currentTopic: null,
  };
}
